import { Interface, type } from 'implement-js'

export const ProvidersInterface = Interface('Providers')(
  {
    AuthenticationProvider: type('function'),
  },
  { error: true },
)
